import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { Event } from '@/modules/backend/Entities/Event';
import { FetchEventData } from '@/modules/backend/Events/FetchEventData';
import homeSmartApi from '@/plugins/HomeSmartApi';

/**
 * @package store.dashboard.events
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class EventsModule
 */
@Module({ name: 'dashboard/events', store, namespaced: true })
export class EventsModule extends VuexModule {
  private _events: Event[] = [];
  private _count = 0;

  public get events(): Event[] {
    return this._events || [];
  }

  public get count(): number {
    return this._count;
  }

  @Mutation
  private acceptResult(result: Event[]): void {
    this._events = result;
  }

  @Mutation
  private totalCount(result: Event): void {
    this._count = result.total;
  }

  @Action({ rawError: true })
  public async fetch(data: FetchEventData): Promise<void> {
    const result = await homeSmartApi.Events.fetch(data);
    this.context.commit('totalCount', result);
    this.context.commit('acceptResult', result.events);
  }
}
